// TeamMemberPopup.js
import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { MultipleSelectDropDownListPaginationComponent } from '../casp/common/MultipleSelectDropDownPaginationList';
import { getUserList } from '../../api/casp/user';
import { Role } from '../../constants/Role';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { addProjectUser } from '../../api/casp/project';
import { withTranslation } from 'react-i18next';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';

const TeamMemberPopup = ({ open, onClose, onAddTeamMember, projectId, t }) => {
    const loggedInUser = useSelector((state) => state.Profile.user)
    const roles = useSelector((state) => state.Roles.roles)
    const [isLoading, setIsLoading] = useState(false)
    const [teamMembers, setTeamMembers] = useState([]); // Store team members here
    const handleAddTeamMember = async () => {
        try {
            if (teamMembers && teamMembers.length > 0) {
                setIsLoading(true)
                const payload = {
                    companyId: loggedInUser?.company.id,
                    projectId,
                    userIds: teamMembers,
                    roleId: (roles.filter((it) => it.name === Role.MEMBER))[0].id
                }
                const response = await addProjectUser(payload)
                if (response.statusCode === 200) {
                    toast.success(response.data.message)
                    onAddTeamMember()
                    handleClose()
                } else {
                    toast.error(response.data.message)
                    setIsLoading(false)
                }
            }
            else {
                setIsLoading(false)
                return toast.error("Please select atleast one user")
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.message);
        }
    };
    const handleClose = () => {
        setIsLoading(false)
        setTeamMembers([])
        onClose();
    };

    return (
        // <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: { width: "580px" },
            }}
            className="projectListDrawer"
        >
            <form className="p-3">
                <h5>{t("Add Team Member")}</h5>
                <CloseIcon className="crossIcon" onClick={handleClose} />
                {/* <List className="createTaskPopup addMilestoneHeading addTeamMember"> */}
                <div className="innerTbContent">
                    <div className="row">
                        {/* <ListItem>
                    <div className='popHeading d-flex justify-content-between align-items-center w-100 mb-2'>
                        <ListItemText>{t("Add Team Member")}</ListItemText>
                        <CancelOutlinedIcon
                            onClick={handleClose}
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                </ListItem> */}
                        <div className="col-sm-12 mb-3 plSelectTypeField">
                            <MultipleSelectDropDownListPaginationComponent
                                fullWidth
                                label={t("Multiple Users") + " *"}
                                searchEnabled={true}
                                listCall={getUserList}
                                apiParams={{
                                    filterFields: "roleId",
                                    filterInputs: 'null',
                                    excludeFilterFields: ["projectUser"],
                                    excludeFilterInputs: [projectId],
                                    isActive: true
                                }}
                                emitItem={(users) => {
                                    if (users && users.length > 0) {
                                        setTeamMembers(users.map((eachUser) => eachUser.id))
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="plsubmitButton">
                    <Button
                        onClick={handleClose}
                        variant="contained"
                        className="drawerCommonBtn redButton mx-1"
                        disabled={isLoading}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        onClick={handleAddTeamMember}
                        variant="contained"
                        className="submitBtn btn addNew_ProjectBtn mx-1"
                        disabled={isLoading}
                    >
                        {t("Add")}
                    </Button>
                </div>
            </form>
        </Drawer>
    );
};

export default withTranslation()(TeamMemberPopup);
